<template>
	<div>
		<vx-card title="Verpakkingen" class="card-body">
			<template slot="actions">
				<vx-tooltip class="flex" text="Hoe en wat?">
					<font-awesome-icon icon="question-circle" @click="wiki"></font-awesome-icon>
				</vx-tooltip>
			</template>
			<div class="vx-row mb-2">
				<div class="vx-col w-4/12">
					<label class="multiselect-label">Aantal per pagina</label>
					<vue-multiselect
						style="width: 140px; z-index: 401"
						placeholder="Producten"
						v-model="options.pageSize.selected"
						:options="options.pageSize.options"
						:show-labels="false"
						:allow-empty="false"
					/>

				</div>
				<div class="vx-col w-8/12">
					<div class="vx-row float-right">
						<div class="vx-col w-auto">
							<vs-input id="search" label="Zoeken" v-model="options.search" size="middle" style="width: 200px" />

						</div>
						<div class="vx-col w-auto">
							<vs-button type="border" line-origin="center" @click.native="openCreatePopup" color="primary" style="margin-top: 21px">
								Nieuw
								<font-awesome-icon icon="plus"></font-awesome-icon>
							</vs-button>
						</div>
					</div>
				</div>
			</div>
			<vs-table
				:data="packages"
				noDataText="Geen verpakking(en) gevonden..."
			>
				<template slot="thead">
					<div class="vx-row w-full">
						<vs-th class="vs-col w-full sm:w-2/12 md:w-3/12 lg:w-3/12">Naam</vs-th>
						<vs-th class="vs-col w-full sm:w-6/12 md:w-5/12 lg:w-5/12">Vooraad</vs-th>
						<vs-th class="vs-col w-1/2 sm:w-2/12 md:w-2/12 lg:w-2/12">Gewicht (Gram)</vs-th>
						<vs-th class="vs-col w-1/2  sm:w-1/12 md:w-2/12 lg:w-2/12" style="width: 100px">Acties</vs-th>
					</div>
				</template>

				<vs-tr v-for="singlePackage in packages" :key="singlePackage.id">
					<div class="vx-row w-full">
						<div class="vs-col w-full sm:w-2/12 md:w-3/12 lg:w-3/12">
							<vs-td>
								{{ singlePackage.name }}
							</vs-td>
						</div>

						<div class="vs-col w-full sm:w-6/12 md:w-5/12 lg:w-5/12">
							<div
								v-if="singlePackage.stock > singlePackage.stock_threshold || singlePackage.stock_threshold < singlePackage.stock">
								<vs-td>
									{{ singlePackage.stock }}
									<vs-progress style="width: 250px" color="success"
												 :percent="singlePackage.stock" />
								</vs-td>
							</div>

							<div
								v-if="singlePackage.stock > 0 && singlePackage.stock <= singlePackage.stock_threshold || singlePackage.stock > 0 && singlePackage.stock_threshold >= singlePackage.stock ">
								<vs-td>
									{{ singlePackage.stock }}
									<vx-tooltip text="Voorraad is lager dan de ingestelde voorraad drempel"
												position="right">
										<vs-progress style="width: 250px" color="warning"
													 :percent="singlePackage.stock" />
									</vx-tooltip>
								</vs-td>
							</div>

							<div v-if="singlePackage.stock <= 0 ">
								<vs-td>
									{{ singlePackage.stock }}
									<vx-tooltip text="Verpakking is uit voorraad" position="right">
										<vs-progress style="width: 250px;" color="danger"
													 :percent="singlePackage.stock" />
									</vx-tooltip>
								</vs-td>
							</div>
						</div>

						<div class="vs-col w-1/2  sm:w-2/12 md:w-2/12 lg:w-2/12">
							<vs-td>
								{{ singlePackage.weight }}
							</vs-td>
						</div>

						<div class="vs-col w-1/2  sm:w-1/12 md:w-2/12 lg:w-2/12">
							<vs-td>
								<vs-button @click.native="openInfoPopup(singlePackage)" radius color="primary"
										   type="flat">
									<font-awesome-icon icon="info-circle"></font-awesome-icon>
								</vs-button>
							</vs-td>
						</div>
					</div>
				</vs-tr>

			</vs-table>
			<br />
			<div class="vx-row justify-center">
				<div class="vx-col">
					<vs-pagination :total="maxPages" v-model="page"></vs-pagination>
				</div>
			</div>
		</vx-card>

		<vs-popup title="Informatie" :active.sync="infoPopup">
			<div v-if="selectedPackage.stock === 0">
				<vs-alert color="danger" active="true">
					Verpakking is uit voorraad!
				</vs-alert>
			</div>

			<vs-tabs>
				<vs-tab label="Algemeen">
					<div class="tab-text">
						<table>
							<tr>
								<td style="width: 150px"><b>Naam</b></td>
								<td>{{ selectedPackage.name }}</td>
							</tr>
							<tr>
								<td style="width: 150px"><b>Gewicht (Gram)</b></td>
								<td>{{ selectedPackage.weight }}</td>
							</tr>
							<tr>
								<td style="width: 150px"><b>Brievenbus</b></td>
								<td>
									<font-awesome-icon icon="check" v-if="selectedPackage.mailbox === 1"></font-awesome-icon>
									<font-awesome-icon icon="times" v-if="selectedPackage.mailbox === 0"></font-awesome-icon>
								</td>

							</tr>
						</table>
					</div>
				</vs-tab>

				<vs-tab label="Voorraad">
					<div class="tab-text">
						<table>
							<tr>
								<td style="width: 150px"><b>Voorraad</b></td>
								<td>{{ selectedPackage.stock }}</td>
							</tr>
							<tr>
								<td style="width: 150px"><b>Voorraad drempel</b></td>
								<td>{{ selectedPackage.stock_threshold }}</td>
							</tr>
						</table>
					</div>
				</vs-tab>

				<vs-tab label="Inkoop">
					<div class="tab-text">
						<table>
							<tr>
								<td style="width: 150px"><b>Inkoop prijs</b></td>
								<td>€{{ selectedPackage.purchase_price }}</td>
							</tr>
							<tr>
								<td style="width: 150px"><b>Inkoop url</b></td>
								<td v-if="selectedPackage.buy_url">{{ selectedPackage.buy_url }}
									<a v-bind:href="selectedPackage.buy_url" target="_blank">
										<font-awesome-icon icon="external-link-alt"></font-awesome-icon>
									</a>
								</td>
								<td v-if="!selectedPackage.buy_url">Deze verpakking heeft geen inkoop url</td>
							</tr>
						</table>
					</div>
				</vs-tab>
			</vs-tabs>

			<vs-divider></vs-divider>

			<div class="vx-row">
				<div class="vx-col w-full text-right">
					<vs-button @click.native="openConfirmDelete()" type="flat" color="danger">Verwijderen
					</vs-button>
					<vs-button @click.native="openEditPopup(selectedPackage)" type="flat" color="primary">
						Bewerken
					</vs-button>
				</div>
			</div>

			<vs-popup title="Bewerken" :active.sync="editPopup">
				<form data-vv-scope="editForm">
					<vs-tabs>
						<vs-tab label="Algemeen">
							<div class="tab-text">
								<div class="vx-row mb-6">
									<div class="vx-col sm:w-1/3 w-full">
										<span>Verpakkings naam *</span>
									</div>
									<div class="vx-col sm:w-2/3 w-full">
										<vs-input v-validate="'required'" name="name" class="w-full" type="name"
												  v-model="selectedPackage.name" />
										<span class="text-danger text-sm" v-show="errors.has('editForm.name')">{{
												errors.first('editForm.name')
											}}</span>
									</div>
								</div>
								<div class="vx-row mb-6">
									<div class="vx-col sm:w-1/3 w-full">
										<span>Gewicht (Gram) *</span>
									</div>
									<div class="vx-col">
										<vs-input-number v-validate="'required'" name="weight"
														 v-model="selectedPackage.weight"></vs-input-number>
										<span class="text-danger text-sm" v-show="errors.has('editForm.weight')">{{
												errors.first('editForm.weight')
											}}</span>
									</div>
								</div>
								<div class="vx-row mb-6">
									<div class="vx-col sm:w-1/3 w-full">
										<span>Brievenbus</span>
									</div>
									<div class="vx-col">
										<vs-checkbox name="mailbox" v-model="selectedPackage.mailbox"></vs-checkbox>
									</div>
								</div>
							</div>
						</vs-tab>
						<vs-tab label="Voorraad">
							<div class="vx-row mb-6">
								<div class="vx-col sm:w-1/3 w-full">
									<span>Voorraad *</span>
								</div>
								<div class="vx-col">
									<vs-input-number v-validate="'required'" name="stock"
													 v-model="selectedPackage.stock"></vs-input-number>
									<span class="text-danger text-sm" v-show="errors.has('editForm.stock')">{{
											errors.first('editForm.stock')
										}}</span>
								</div>
							</div>
							<div class="vx-row mb-6">
								<div class="vx-col sm:w-1/3 w-full">
									<span>Voorraad drempel</span>
								</div>
								<div class="vx-col">
									<vs-input-number name="stock_threshold"
													 v-model="selectedPackage.stock_threshold"></vs-input-number>

								</div>
							</div>
						</vs-tab>
						<vs-tab label="Inkoop">
							<div class="tab-text">
								<div class="vx-row mb-6">
									<div class="vx-col sm:w-1/3 w-full">
										<span>Inkoop prijs *</span>
									</div>
									<div class="vx-col">
										<vs-input-number v-validate="'required'" name="purchase_price"
														 v-model="selectedPackage.purchase_price"></vs-input-number>
										<span class="text-danger text-sm"
											  v-show="errors.has('editForm.purchase_price')">{{
												errors.first('editForm.purchase_price')
											}}</span>

									</div>
								</div>
								<div class="vx-row mb-6">
									<div class="vx-col sm:w-1/3 w-full">
										<span>Inkoop url </span>
									</div>
									<div class="vx-col">
										<vs-input v-validate="'url'" name="buy_url"
												  v-model="selectedPackage.buy_url"></vs-input>
										<span class="text-danger text-sm" v-show="errors.has('editForm.buy_url')">{{
												errors.first('editForm.buy_url')
											}}</span>
									</div>
								</div>
							</div>
						</vs-tab>
					</vs-tabs>
					<vs-divider></vs-divider>
					<div class="vx-row">
						<div class="vx-col w-full text-right">
							<vs-button color="warning" type="flat" @click.native="closeEditPopup">Annuleer</vs-button>
							<vs-button class="mr-3 mb-2" @click.native="editPackage">Opslaan</vs-button>
						</div>
					</div>
				</form>
			</vs-popup>

			<vs-popup :active.sync="confirmDelete" title="Verpakking verwijderen">
				<vs-row vs-w="12">
					<vs-col>
						Je staat op het punt de verpakking "{{ selectedPackage.name }}" te verwijderen!<br />
						Weet je het zeker?
					</vs-col>
				</vs-row>
				<vs-divider></vs-divider>
				<div class="vx-row">
					<div class="vx-col w-full text-right">
						<vs-button @click.native="closeConfirmDelete" type="filled" color="primary">Nee, ga terug!</vs-button>
						<vs-button type="flat" color="danger" @click.native="deletePackages('editForm')">Ja, verwijderen!</vs-button>
					</div>
				</div>
			</vs-popup>
		</vs-popup>

		<vs-popup title="Toevoegen" :active.sync="createPopup">
			<form data-vv-scope="createForm">
				<vs-tabs>
					<vs-tab label="Algemeen">
						<div class="tab-text">
							<div class="vx-row mb-6">
								<div class="vx-col sm:w-1/3 w-full">
									<span>Verpakkings naam *</span>
								</div>
								<div class="vx-col sm:w-2/3 w-full">
									<vs-input v-validate="'required'" name="name" class="w-full" type="name"
											  v-model="packageData.name" />
									<span class="text-danger text-sm" v-show="errors.has('createForm.name')">{{
											errors.first('createForm.name')
										}}</span>
								</div>
							</div>
							<div class="vx-row mb-6">
								<div class="vx-col sm:w-1/3 w-full">
									<span>Gewicht (Gram) *</span>
								</div>
								<div class="vx-col">
									<vs-input-number v-validate="'required'" type="number" name="weight"
													 v-model="packageData.weight"></vs-input-number>
									<span class="text-danger text-sm" v-show="errors.has('createForm.weight')">{{
											errors.first('createForm.weight')
										}}</span>

								</div>
							</div>
							<div class="vx-row mb-6">
								<div class="vx-col sm:w-1/3 w-full">
									<span>Brievenbus</span>
								</div>
								<div class="vx-col">
									<vs-checkbox name="mailbox" v-model="packageData.mailbox"></vs-checkbox>
								</div>
							</div>
						</div>
					</vs-tab>
					<vs-tab label="Voorraad">
						<div class="vx-row mb-6">
							<div class="vx-col sm:w-1/3 w-full">
								<span>Voorraad *</span>
							</div>
							<div class="vx-col">
								<vs-input-number v-validate="'required'" type="number" name="stock"
												 v-model="packageData.stock"></vs-input-number>
								<span class="text-danger text-sm" v-show="errors.has('createForm.stock')">{{
										errors.first('createForm.stock')
									}}</span>

							</div>
						</div>
						<div class="vx-row mb-6">
							<div class="vx-col sm:w-1/3 w-full">
								<span>Voorraad drempel</span>
							</div>
							<div class="vx-col">
								<vs-input-number type="number" name="stock_threshold"
												 v-model="packageData.stock_threshold"></vs-input-number>

							</div>
						</div>
					</vs-tab>
					<vs-tab label="Inkoop">
						<div class="tab-text">
							<div class="vx-row mb-6">
								<div class="vx-col sm:w-1/3 w-full">
									<span>Inkoop prijs *</span>
								</div>
								<div class="vx-col">
									<vs-input-number v-validate="'required'" type="number" name="purchase_price"
													 v-model="packageData.purchase_price"></vs-input-number>
									<span class="text-danger text-sm" v-show="errors.has('createForm.purchase_price')">{{
											errors.first('createForm.name')
										}}</span>
								</div>
							</div>
							<div class="vx-row mb-6">
								<div class="vx-col sm:w-1/3 w-full">
									<span>Inkoop url</span>
								</div>
								<div class="vx-col">
									<vs-input v-validate="'url'" name="buy_url"
											  v-model="packageData.buy_url"></vs-input>
									<span class="text-danger text-sm" v-show="errors.has('createForm.buy_url')">{{
											errors.first('createForm.buy_url')
										}}</span>

								</div>
							</div>
						</div>
					</vs-tab>
				</vs-tabs>
				<div class="vx-row">
					<div class="vx-col w-full text-right">
						<vs-button class="mr-5" color="danger" type="flat" @click.native="closeCreatePopup">Annuleer</vs-button>
						<vs-button class="mr-3 mb-2" @click.native="createPackage">Opslaan</vs-button>
					</div>
				</div>
			</form>
		</vs-popup>
	</div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate';
import {mapActions, mapMutations, mapGetters} from 'vuex';


Vue.use(VeeValidate);
const dict = {
	custom: {
		name: {
			required: 'Dit veld is verplicht',
		},
		stock: {
			required: 'Dit veld is verplicht',
		},
		weight: {
			required: 'Dit veld is verplicht',
		},
		purchase_price: {
			required: 'Dit veld is verplicht',
		},
		mailbox: {
			required: 'Dit veld is verplicht',
		},
		buy_url: {
			url: 'Dit is geen geldige url',
		},

	}
};
Validator.localize('en', dict);

export default {
	name: 'packages',
	data() {
		return {
			packageData: {
				name: '',
				weight: '',
				mailbox: 0,
				stock: '',
				stock_threshold: '',
				purchase_price: '',
				buy_url: '',
			},
			selectedPackage: {},
			infoPopup: false,
			createPopup: false,
			editPopup: false,
			confirmDelete: false,
			options: {
				pageSize: {
					options: [
						10,
						20,
						50,
						100
					],
					selected: 20,
				},
				search: '',
			},
			page: 1,
		}
	},
	mounted() {
		this.$vs.loading();
		this.options.pageSize.selected = this.pageSize;
		if (this.search) {
			this.options.search = this.search;
		}
		this.getPackages().then(res => {
			this.$vs.loading.close();
		}).catch(err => {
			this.$vs.loading.close();
		});
	},
	watch: {
		'options.pageSize.selected'() {
			this.changePageSize()
		},
		'options.search'() {
			if (this.searchTimer) {
				clearTimeout(this.searchTimer);
				this.searchTimer = null;
			}

			this.searchTimer = setTimeout(() => {
				this.searchPackage()
			}, 800);
		},
		'currentPage'(currentPage) {
			this.page = currentPage;
		},
		'page'(page) {
			if (page !== this.currentPage) {
				this.setCurrentPage(page);
				this.getPackages();
			}
		}
	},
	computed: {
		...mapGetters({
			packages: 'packages/packages',
			pageSize: 'packages/pageSize',
			maxPages: 'packages/maxPages',
			search: 'packages/search',
		})
	},
	methods: {
		...mapMutations({
			setSearch: 'packages/SET_SEARCH',
			setPageSize: 'packages/SET_PAGE_SIZE',
			setCurrentPage: 'packages/SET_CURRENT_PAGE',
		}),
		...mapActions({
			getPackages: 'packages/getPackages',

		}),
		openCreatePopup() {
			this.createPopup = true;
		},
		closeCreatePopup() {
			this.createPopup = false;
		},
		openConfirmDelete() {
			this.confirmDelete = true;
		},
		closeConfirmDelete() {
			this.confirmDelete = false;
		},
		openInfoPopup(selectedPackage) {
			this.selectedPackage = selectedPackage;
			this.infoPopup = true;
		},
		openEditPopup(selectedPackage) {
			this.editPopup = true;
			this.selectedPackage.package_id = selectedPackage.id;
		},
		closeEditPopup() {
			this.editPopup = false;
		},
		buyPackage(url) {
			window.open(url, '_blank')
		},
		deletePackages() {
			this.$store.dispatch('packages/deletePackages', this.selectedPackage.id).then(res => {
				this.getPackages()
				this.$vs.notify({
					title: 'Succes',
					text: this.selectedPackage.name + ' is verwijderd',
					color: 'success'
				})
			}).catch(err => {
				this.$vs.notify({
					title: 'Error',
					text: 'De verpakking is niet verwijderd, probeer het opnieuw',
					color: 'danger'
				})
			})
			this.confirmDelete = false
			this.infoPopup = false
		},
		editPackage(scope) {
			this.$validator.validateAll(scope).then(result => {
				if (result) {
					this.$store.dispatch('packages/updatePackages', this.selectedPackage).then(res => {
						this.$vs.notify({
							title: 'Succes',
							text: 'De verpakking is bijgewerkt',
							color: 'success'
						})
						this.editPopup = false
						this.getPackages()
					}).catch(err => {
						this.$vs.notify({
							title: 'Error',
							text: 'De verpakking is niet bijgewerkt, probeer het opnieuw',
							color: 'danger'
						})
					})
				} else {
					this.$vs.notify({
						title: 'Error',
						text: 'controleer je gegevens en probeer het opnieuw',
						color: 'danger'
					})
				}
			})
		},
		createPackage(scope) {
			this.$validator.validateAll(scope).then(result => {
				if (result) {
					this.$store.dispatch('packages/createPackages', this.packageData).then(res => {
						this.$vs.notify({
							title: 'Succes',
							text: 'De verpakking is toegevoegd',
							color: 'success'
						})
						this.createPopup = false;
						this.getPackages();
					}).catch(err => {
						this.$vs.notify({
							title: 'Error',
							text: 'De verpakking is niet toegevoegd, probeer het opnieuw',
							color: 'danger'
						})
					})
				} else {
					this.$vs.notify({
						title: 'Error',
						text: 'controleer je gegevens en probeer het opnieuw',
						color: 'danger'
					})
				}
			})
		},
		searchPackage() {
			if (this.options.search.length >= 2) {
				this.setSearch(this.options.search);
				this.getPackages();
			} else if (!this.options.search.length) {
				this.setSearch(null);
				this.getPackages();
			}
		},
		changePageSize() {
			if (this.options.pageSize.selected > 100) {
				this.options.pageSize.selected = 100;
				this.$vs.notify({
					title: 'Error',
					text: 'Paginagrootte kan maximaal 100 zijn',
					color: 'danger'
				});
			}

			this.setPageSize(this.options.pageSize.selected);
			this.getPackages();
		},
		wiki() {
			window.open(this.$store.state.wiki.wiki.packages)
		}
	}
}
</script>

